import angular from 'angular';

import CalendarRadioComponent from './calendar-radio.cmpt';

export default angular
    .module('application.component.calendar-radio', [])
    .component(CalendarRadioComponent.selector, CalendarRadioComponent);



// WEBPACK FOOTER //
// ./src/application/component/calendar-radio/index.js